import { type Plugin } from "@nuxt/types";

import { keysToCamel, keysToSnake } from "@/utils/transform/object";

const plugin: Plugin = ({ $axios }) => {
  // Convert response body keys inot camelCased format
  $axios.onResponse((response) => {
    response.data = keysToCamel(response.data);
  });

  $axios.onRequest((request) => {
    request.data = keysToSnake(request.data);
  });
};

export default plugin;
